import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { environment } from '@env/environment';
import { LocalDataSource } from 'ng2-smart-table';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { SessionStorage } from 'ngx-webstorage';
import { Subject } from 'rxjs';
import { Actividad } from '../models/actividad.model';
import { Annulation } from '../models/anulacion.model';
import { DocumentoAnexo } from '../models/documento.model';
import { TypeProcess } from '../models/proceso.model';
import { HistorialMicroproceso, Microproceso, Tarea } from '../models/tarea.model';
import { Etapas, Tramite } from '../models/tramite.model';
import { FlowTitle } from '../title';
import { DocumentsRecordsPreviewConfig } from './shared/documents-records-preview.config.service';
import { DocumentsRecordsPreviewService } from './shared/documents-records-preview.data.service';

@Component({
  selector: 'iw-documents-records-preview',
  templateUrl: './documents-records-preview.component.html',
  styleUrls: ['./documents-records-preview.component.scss'],
  providers: [DocumentsRecordsPreviewService]
})
// type Template = "primary";
export class DocumentsRecordsPreviewComponent implements OnInit, OnDestroy {
  // Datos de la tabla
  sourceData: LocalDataSource;
  // datos de tal tabla de anexos
  sourceAttachment: LocalDataSource;
  // Contiene la configuracion de la tabla
  settings = {};
  // Contiene la configuracion de la tabla de anexos
  settingsAttachment = {};
  //estructura de la tabla de documentos personalizada
  structure_table: any[] = [];
  //documentos del expediente
  documents_expedient: any[] = [];
  // documento seleccionado por el usuario
  rowSelect: any = {};
  // accion de descargar 
  accion = '';
  // Contiene el radicado del expediente
  @Input() expediente: any = {};
  // Contiene el nombre del tramite
  @Input() tramite: string;
   // Instancia del trámite(default) seleccionado
  // La instancia puede ser un microproceso
  instance: Tramite | Microproceso;
  data: FlowTitle;
  // Muestra diferentes elementos
  show = {
    // Significado de la iconografía del flujo
    helperFlow: false,
    // Formulario de filtros de consulta
    filterForm: false,
  };
  isLoading = {
    listInstances: false,
    createInstance: false,
    showInstance: false,
    finishTask: false,
    startSecondary: false,
    cancelSecondary: false,
    associationTramite: false,
    alertDynamic: false,
  };
  // Contiene el tipo de proceso que se esta renderizando
  typeProcess: TypeProcess = "process";
  // Contiene las etapas del tramite ( etapa actual y general)
  stage: Etapas;
  // Variable que determina si el formualrio está abierto
  openFormPreview: Boolean = false;
  // id secondary
  idSecondary = -1;
  // id secondary
  idTaskSecondary = -1;
   // Contiene el id de la primera actividad activada
   idActivityFirstActive = -1;
  // Contiene la información de anulación
  annulationInfo: Annulation = {};
  extensionsLabel = '';
  extensionsText = '';
  // Contiene los archivos subidos
  attachedDocuments: DocumentoAnexo[] = [];
  // Actividades de la instancia
  private _activities: Actividad[];
  historysMicroproces = {};
  historyMicroproce: HistorialMicroproceso[];
  idHistorySelect = 0;
  idsSelected: any[] = [];
  // Define el formato en el que el usuario desea ver la informacion de las tareas
  isDesign = "compact";
  // Referencia de la modal
  private modalRef: BsModalRef;
  // Define el formato en el que el usuario desea ver la informacion de las tareas
  @SessionStorage() isDesignTaskPreview: string;
  // Controla si la memorai guardada
  private destroy: Subject<void> = new Subject<void>();
  @ViewChild("templatePreviewAttachments") TplAttachment: TemplateRef<any>;

  constructor(private drds: DocumentsRecordsPreviewService,
    private modalService: BsModalService,
    ) { }

  ngOnInit() {
    //valida si la tabla es por consulta o fija
    if(environment.DocumentExpCustom){
      this.drds.getDocumentExpedient(this.expediente.idExpediente).subscribe(async res=>{
      if(res){
        this.documents_expedient = await res.valores;
        this.documents_expedient.forEach(doc=>{
          doc['value'] = true;
        });
        this.structure_table =  await res.estructura;
        this.structure_table = this.structure_table.sort((a,b)=> a.orden - b.orden);
        const configTable = new DocumentsRecordsPreviewConfig(this.structure_table);
        this.settings = configTable.settings;
        configTable.accion.subscribe((res: any) => {
        if (res.action && res.action == "ver_anexos"){
            if(res.data[res.alias] && res.data[res.alias] != -1){
              this.getAttached(res.data[res.alias]);
            }
          }
          else{
            this.actionTable(res.action);
          }
        });
        this.sourceData = new LocalDataSource(this.documents_expedient);
      }
      })
    }else{
      const configTable = new DocumentsRecordsPreviewConfig();
      this.settings = configTable.settings;
      configTable.accion.subscribe((res: any) => {
          this.actionTable(res.action);
      });
      this.drds.getDocumentExpedient(this.expediente.idExpediente).subscribe(async res=>{
        if(res){
          this.documents_expedient = await res.valores;
          this.documents_expedient.forEach(doc=>{
            doc['value'] = true;
          });
          this.sourceData = new LocalDataSource(this.documents_expedient);
        }
      })
    }
    
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }
  actionTable(action: any){
    this.accion = action;
    
  }

  async downloadDoc(data: any){
    this.rowSelect = await  data.data
    if(this.accion == 'descargar' && this.rowSelect && (this.rowSelect.anexo == undefined || this.rowSelect.anexo == false)){
      this.drds.dowloadFile(this.rowSelect.id_documento).subscribe((res: any) => {
        const a = document.createElement('a');
        a.target = '_blank';
        a.href = res.file.path;
        a.download = res.file.name;
        a.click();
        a.remove();
        this.accion = '';
      });
    }else if(this.accion == 'descargar'  && this.rowSelect && this.rowSelect.anexo != undefined && this.rowSelect.anexo == true){
      this.drds.getDownloadAttachedDocument(this.rowSelect.id_documento).subscribe(res => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.target = '_blank';
        a.href = res.path;
        a.download = res.name;
        a.click();
        window.URL.revokeObjectURL(res.path);
        a.remove();
        this.accion = '';
      });
    }
  }

    /**
   * Consulta los anexos del documento.
   *
   * @param {number} idDocument
   * @memberof DocumentsRecordsPreviewComponent
   */
    getAttached(idDocument: number) {
      let configTable = new DocumentsRecordsPreviewConfig();
        this.settingsAttachment = configTable.settingsAttachment;
        configTable.accionAttachment.subscribe((data: any) => {
          this.accionTable(data.action, data.value.id);
        });
      this.drds.getAttachedDocument(idDocument).subscribe(async documents => {
        this.attachedDocuments = await documents;
        if (this.attachedDocuments.length) {
          this.attachedDocuments.map(document => {
            if (document.fecha_registro) {
              const date = new Date(document.fecha_registro);
              document.fecha_registro = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
            }
            document['finish'] = true;
          });
        }
        this.sourceAttachment = new LocalDataSource(this.attachedDocuments);
        this.modalRef = this.modalService.show(
          this.TplAttachment,{ class:  'modal-personalized-form', ignoreBackdropClick: true }
        );
      });
  }

  /**
   * Controla las acciones en la tabla de anexos
   *
   * @param {string} action
   * @param {*} data
   * @memberof DocumentsRecordsPreviewComponent
   */
   accionTable(action: string, data: any) {
    switch (action) {
      case 'dowmload':
        this.drds.getDownloadAttachedDocument(data).subscribe(res => {
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.target = '_blank';
          a.href = res.path;
          a.download = res.name;
          a.click();
          window.URL.revokeObjectURL(res.path);
          a.remove();
          this.accion = '';
        });
        break;
    }
  }

  closeModalAttached(){
    this.modalRef.hide();
    this.attachedDocuments = [];
    this.settingsAttachment = {};
  }
    

}



// WEBPACK FOOTER //
// ./src/app/shared/documents-records-preview/documents-records-preview.component.ts